import { ArrowDownward } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Button, Divider, Grid, Stack, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import Basics from './Basics';
import Fields from './Fields';

const Elements = ({ handleDragStart, handleAdd, isFromStepper, disabled, isEditing }: any) => {
  const intl = useIntl();
  const navigate = useNavigate();
  return (
    <Grid container direction="column" minHeight={isFromStepper ? '81vh' : '91vh'} p={isFromStepper ? 0 : 2}>
      <Grid item xs={4}>
        <Accordion>
          <AccordionSummary expandIcon={<ArrowDownward />} aria-controls="basics-content" id="basics-header">
            <Typography sx={{ color: '#393939', fontSize: 18, fontWeight: 500 }}>
              {intl.formatMessage({ defaultMessage: 'Basics' })}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Basics handleDragStart={handleDragStart} />
          </AccordionDetails>
        </Accordion>
      </Grid>
      <Divider />
      <Grid item xs={4}>
        <Accordion>
          <AccordionSummary expandIcon={<ArrowDownward />} aria-controls="fields-content" id="fields-header">
            <Typography sx={{ color: '#393939', fontSize: 18, fontWeight: 500 }}>
              {intl.formatMessage({ defaultMessage: 'Fields' })}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Fields handleDragStart={handleDragStart} />
          </AccordionDetails>
        </Accordion>
      </Grid>
      <Grid item xs={4} p={2} sx={{ marginTop: 'auto' }}>
        <Stack direction="row" gap={1}>
          <Button variant="contained" fullWidth color="error" onClick={() => navigate('/forms')}>
            {intl.formatMessage({ defaultMessage: 'Cancel' })}
          </Button>
          <Button variant="contained" fullWidth onClick={handleAdd}>
            {isEditing ? intl.formatMessage({ defaultMessage: 'Update' }) : intl.formatMessage({ defaultMessage: 'Create' })}
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default Elements;
